module.exports = __webpack_public_path__ + "img/sportsbook.d9696bfb.png";